import { motion } from "framer-motion";
import { SectionHead } from "./Reveal";
import { PROCESS_STEPS } from "../data/site";

export const Process = () => (
  <section id="process" data-testid="process-section" className="bg-[#0A0A0A] px-6 py-24 md:px-12 md:py-32">
    <div className="mx-auto max-w-7xl">
      <SectionHead
        id="process"
        overline="Chapter 05 — How We Work"
        title="Our Process"
        desc="A structured six-step workflow that takes your project from first conversation to finished structure."
      />

      <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3">
        {PROCESS_STEPS.map((step, i) => (
          <motion.div
            key={step.title}
            data-testid={`process-step-${i + 1}`}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: (i % 3) * 0.1, ease: [0.16, 1, 0.3, 1] }}
            className="group relative border border-white/10 bg-[#050505] p-8 transition-colors duration-500 hover:border-[#0055FF]/60"
          >
            <div className="flex items-center gap-4">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center border border-[#0055FF]/50 font-display text-sm font-bold text-[#3377FF] transition-colors group-hover:bg-[#0055FF] group-hover:text-white">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="h-px flex-1 bg-gradient-to-r from-[#0055FF]/60 to-transparent" aria-hidden />
            </div>
            <h3 className="mt-6 font-display text-xl font-semibold tracking-tight">
              Step {i + 1} — {step.title}
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-[#A3A3A3]">{step.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
